import { render, staticRenderFns } from "./CertifyModal.vue?vue&type=template&id=77f3b20c"
import script from "./CertifyModal.vue?vue&type=script&lang=js"
export * from "./CertifyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports